module.exports = __webpack_public_path__ + "img/filter-list-24px@2x.8d79b38c.png";